import React, { useEffect } from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarContent,
} from "react-pro-sidebar";
import { Link } from "react-router-dom";

import userDefaultPerfil from "../images/perfil2.png";

import { useDispatch, useSelector } from "react-redux";
import { singOut } from "../redux/auth/actions";
import { withRouter } from "react-router";
// import { getAuth } from '../redux/auth/actions';

const SidebarConfig = (props) => {
  const dispatch = useDispatch();
  const userPic = useSelector((store) => store.auth.pic);
  const userN = useSelector((store) => store.auth.name);
  const userId = useSelector((store) => store.auth.id);
  const userType = useSelector((store) => store.auth.userType);

  const onSignOut = (e) => {
    e.preventDefault();
    dispatch(singOut(props));
  };

  return (
    <>
      <ProSidebar
        collapsed={false}
        className={`custom-sidebar ${props.show ? "show-sidebar" : ""}`}
        toggled={"fixed"}
      >
        <SidebarContent style={{ overflowY: "auto" }}>
          <Menu iconShape="square">
            <div className="d-block d-sm-block d-md-none">
              <SubMenu
                title={userN ? userN : null}
                icon={
                  <img
                    src={!!userPic ? userPic : userDefaultPerfil}
                    className="user-pic"
                  />
                }
              >
                <MenuItem>
                  <Link to={`/perfil-usuario/${userId}/${userType}`}>
                    Mi perfil
                  </Link>
                </MenuItem>
                {/* <MenuItem><Link to="Dashboard-Headcount">Dashboard</Link></MenuItem> */}
                <MenuItem style={{ borderBottom: "2px solid white" }}>
                  <Link to={`/perfil-usuario/${userId}`}>Mi perfil</Link>
                </MenuItem>
                <div className="row no-gutters"></div>
                <MenuItem
                  icon={<i className="material-icons">notifications</i>}
                >
                  <Link to="/#!">Notificaciones</Link>
                </MenuItem>
                <MenuItem onClick={onSignOut}>Cerrar sesión</MenuItem>
              </SubMenu>
            </div>
            {/* <MenuItem icon={<i className="material-icons">face</i>}><Link to="/Dashboard-Headcount">Dashboard</Link></MenuItem> */}
            <MenuItem icon={<i className="material-icons">face</i>}>
              <Link to={`/detalle-empleado/${userId}/${userType}`}>
                Ficha de empleado
              </Link>
            </MenuItem>
            <SubMenu
              title="Mant. Geográfico"
              icon={<i className="material-icons">location_on</i>}
            >
              <MenuItem>
                <Link to="/country-maintenance">Mant. País</Link>
              </MenuItem>
              <MenuItem>
                <Link to="/department-maintenance">Mant. Departamento</Link>
              </MenuItem>
              <MenuItem>
                <Link to="/municipality-maintenance">Mant. Municipio</Link>
              </MenuItem>
            </SubMenu>
            <MenuItem icon={<i className="material-icons">group</i>}>
              <Link to="/cargos/2">Posición</Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">group</i>}>
              <Link to="/relacion-posicion">Posición por relación</Link>
            </MenuItem>
            {/* <SubMenu title="Puestos" icon={<i className="material-icons">group</i>}>
              <MenuItem icon={<i className="material-icons">group</i>}><Link to="/cargos-formal">Formal</Link></MenuItem>
            </SubMenu> */}
            {/* <MenuItem icon={<i className="material-icons">engineering</i>}><Link to="/plazas">Función</Link></MenuItem> */}
            {/* <SubMenu title="Plazas" icon={<i className="material-icons">engineering</i>}>
              <MenuItem icon={<i className="material-icons">engineering</i>}><Link to="/plazas-formal">Formal</Link></MenuItem>
            </SubMenu> */}
            <MenuItem icon={<i className="material-icons">engineering</i>}>
              <Link to="/tareas/2">Funciones</Link>
            </MenuItem>
            {/* <SubMenu title="Funciones" icon={<i className="material-icons">engineering</i>}>
              <MenuItem><Link to="/tareas/2">Funcional</Link></MenuItem>
              <MenuItem><Link to="/tareas/1">Formal</Link></MenuItem>
            </SubMenu> */}
            <SubMenu
              title="Mant. empleados"
              icon={<i className="material-icons">manage_accounts</i>}
            >
              <MenuItem>
                <Link to="/empresas-filtro-empleados/2">Funcional</Link>
              </MenuItem>
              <MenuItem>
                <Link to="/empresas-filtro-empleados/1">Formal</Link>
              </MenuItem>
            </SubMenu>
            <SubMenu
              title="Clasificación"
              icon={<i className="material-icons">label</i>}
            >
              <MenuItem>
                <Link to="/clasificación/2">Funcional</Link>
              </MenuItem>
              <MenuItem>
                <Link to="/clasificación/1">Formal</Link>
              </MenuItem>
            </SubMenu>
            <MenuItem icon={<i className="material-icons">location_city</i>}>
              <Link to="/institutos/2">Mant. institutos</Link>
            </MenuItem>
            {/* <SubMenu title="Mant. institutos" icon={<i className="material-icons">location_city</i>}>
              <MenuItem icon={<i className="material-icons">perm_data_settings</i>}><Link to="/institutos-formal">Formal</Link></MenuItem>
            </SubMenu> */}
            <MenuItem icon={<i className="material-icons">history_edu</i>}>
              <Link to="/especializacion/2">Mant. especialización</Link>
            </MenuItem>
            {/* <SubMenu title="Mant. especialización" icon={<i className="material-icons">history_edu</i>}>
              <MenuItem icon={<i className="material-icons">perm_data_settings</i>}><Link to="/especializacion-formal">Formal</Link></MenuItem>
            </SubMenu> */}
            <MenuItem icon={<i className="material-icons">school</i>}>
              <Link to="/titulo/2">Mant. título</Link>
            </MenuItem>
            {/* <SubMenu title="Mant. título" icon={<i className="material-icons">school</i>}>
              <MenuItem icon={<i className="material-icons">perm_data_settings</i>}><Link to="/titulo-formal">Formal</Link></MenuItem>
            </SubMenu> */}
            <MenuItem icon={<i className="material-icons">dns</i>}>
              <Link to={`/division/2`}>Mant. división</Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">category</i>}>
              <Link to="/division-personal/2">Mant. división personal</Link>
            </MenuItem>
            {/* <SubMenu title="Mant. división personal" icon={<i className="material-icons">category</i>}>
              <MenuItem icon={<i className="material-icons">perm_data_settings</i>}><Link to="/division-personal-formal">Formal</Link></MenuItem>
            </SubMenu> */}
            <MenuItem icon={<i className="material-icons">local_pharmacy</i>}>
              <Link to="/diagnosticos/2">Mant. diagnósticos</Link>
            </MenuItem>
            {/* <SubMenu title="Mant. diagnósticos" icon={<i className="material-icons">local_pharmacy</i>}>
              <MenuItem icon={<i className="material-icons">perm_data_settings</i>}><Link to="/diagnosticos-formal">Formal</Link></MenuItem>
            </SubMenu> */}
            <SubMenu
              title="Mant. laboratorios"
              icon={<i className="material-icons">biotech</i>}
            >
              <MenuItem>
                <Link to="/mantenimiento-laboratorios/2">Funcional</Link>
              </MenuItem>
              <MenuItem>
                <Link to="/mantenimiento-laboratorios/1">Formal</Link>
              </MenuItem>
            </SubMenu>
            <SubMenu
              title="Mant. vacunas"
              icon={<i className="material-icons">vaccines</i>}
            >
              <MenuItem>
                <Link to="/mantenimiento-vacunas/2">Funcional</Link>
              </MenuItem>
              <MenuItem>
                <Link to="/mantenimiento-vacunas/1">Formal</Link>
              </MenuItem>
            </SubMenu>
            <MenuItem icon={<i className="material-icons">how_to_reg</i>}>
              <Link to="/usuarios">Usuarios</Link>
            </MenuItem>
            <MenuItem
              icon={<i className="material-icons">perm_data_setting</i>}
            >
              <Link to="/unidad/2">Mant. unidad</Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">business</i>}>
              <Link to="/cost-center-maintenance">Mant. Centro de Costo</Link>
            </MenuItem>
            {/* <SubMenu title="Mant. área" icon={<i className="material-icons">perm_data_setting</i>}>
              <MenuItem icon={<i className="material-icons">perm_data_settings</i>}><Link to="/unidad-formal">Formal</Link></MenuItem>
            </SubMenu> */}
            <MenuItem icon={<i className="material-icons">work</i>}>
              <Link to="/func-formacion/2">Formación</Link>
            </MenuItem>
            {/* <SubMenu title="Formación" icon={<i className="material-icons">work</i>}>
              <MenuItem><Link to="/form-formacion">Formal</Link></MenuItem>
            </SubMenu> */}
            <SubMenu
              title="Checklist doc"
              icon={<i className="material-icons">rule_folder</i>}
            >
              <MenuItem>
                <Link to="/mantenimiento-documentacion/2">Funcional</Link>
              </MenuItem>
              <MenuItem>
                <Link to="/mantenimiento-documentacion/1">Formal</Link>
              </MenuItem>
            </SubMenu>
            <MenuItem icon={<i className="material-icons">rule_folder</i>}>
              <Link to="/excel-carga-masiva">Carga masiva checklist</Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">update</i>}>
              <Link to="/administrador-configuracion">Act. de información</Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">notifications</i>}>
              <Link to="/notificaciones-de-no-ingreso">Notificaciones</Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">meeting_room</i>}>
              <Link to="/reporte-inicio-sesión">Inf. de Inicio de Sesión</Link>
            </MenuItem>
            {/* <MenuItem icon={<i className="material-icons">category</i>}><Link to="/categorias">Categorias</Link></MenuItem>
            <MenuItem icon={<i className="material-icons">straighten</i>}><Link to="/mediciones">Mediciones</Link></MenuItem>
            <MenuItem icon={<i className="material-icons">construction</i>}><Link to="/herramienta">Tipo de herramienta</Link></MenuItem> */}
          </Menu>
        </SidebarContent>
      </ProSidebar>
      <div
        onClick={() => props.onShowSidebar()}
        className={`overlay ${props.show ? "show-overlay" : ""}`}
      ></div>
    </>
  );
};

export default withRouter(SidebarConfig);
